var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReconciliation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.316,
    height: 34.094,
    viewBox: "0 0 31.316 34.094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reconciliation",
    transform: "translate(-0.04 0.03)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 18.319,
    height: 1.823,
    transform: "translate(3.682 14.122)",
    fill: "#ec0000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 7.485,
    height: 1.823,
    transform: "translate(3.682 27.911)",
    fill: "#ec0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1434",
    "data-name": "Path 1434",
    d: "M328.483,115.4l-1.97-1.97a2.254,2.254,0,0,0-3.169-.3l-3.5,3.5H303v1.823h15.023l-2.7,2.7a.883.883,0,0,0-.211.338l-2.147,6.2a.886.886,0,0,0,1.094,1.139l6.191-1.872a.879.879,0,0,0,.37-.221l2.558-2.558v4.637a2.44,2.44,0,0,1-2.437,2.437H303.569a2.44,2.44,0,0,1-2.438-2.437V108.65h7.853v-.836h9.145a6.5,6.5,0,0,0,1.009,1.723H303v1.823h18.319v-.1a6.5,6.5,0,1,0,.655-11.943,4.2,4.2,0,0,0-1.235-.194H307.633L299.36,107.4v21.419a4.215,4.215,0,0,0,4.211,4.21h17.17a4.215,4.215,0,0,0,4.21-4.21V122.4l3.837-3.837a1.892,1.892,0,0,0,.492-1.662A2.79,2.79,0,0,0,328.483,115.4Zm-26.1-8.52,4.827-4.827v4.827Zm6.6-.886v-5.1h10.532a6.456,6.456,0,0,0-1.847,4.534c0,.19.012.377.028.563Zm19.907-.563a4.727,4.727,0,1,1-4.727-4.725,4.728,4.728,0,0,1,4.727,4.725ZM318.863,125.52l-2.84.862-.539-.552.948-2.738Zm1.485-1.023-.788-.788,3.95-3.951-1.253-1.253-3.951,3.955-.891-.892,4.836-4.84,2.934,2.935Zm7.188-7.184-1.1,1.1-2.936-2.935,1.084-1.086a.8.8,0,0,1,.675.294l1.966,1.97A.85.85,0,0,1,327.536,117.314Z",
    transform: "translate(-299.32 -98.96)",
    fill: "#ec0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1435",
    "data-name": "Path 1435",
    d: "M388.539,71.066l-1.393-1.1-2.834,3.6-1.6-1.285L381.6,73.669l3,2.4Z",
    transform: "translate(-360.086 -66.06)",
    fill: "#ec0000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReconciliation);
export default __webpack_public_path__ + "static/media/Reconciliation.f9706ec3a3f60ce1a049947c2235e868.svg";
export { ForwardRef as ReactComponent };